import { WSList } from "@wingspanhq/fe-component-library";
import { useRouteMatch } from "react-router-dom";
import { FlowAddPayoutMethod } from "../../Settings/components/payout/FlowAddPayoutMethod";
import { CardPayoutMethodRequirementRequester } from "../components/CardPayoutMethodRequirementRequester";
import { useOnboardignModules } from "../Context";
import { OnboardingModulePayoutMethod, OnboardingStep } from "../types";

export const PayoutMethod: React.FC<OnboardingStep> = ({ onNext }) => {
  const match = useRouteMatch();
  const modules = useOnboardignModules();
  const onboardingModule = modules.find(m => m.type === "payout_method") as
    | OnboardingModulePayoutMethod
    | undefined;

  return (
    <WSList gap="2XL">
      <CardPayoutMethodRequirementRequester />

      <FlowAddPayoutMethod
        basePath={match.path}
        onNext={onNext}
        availableUsMethods={onboardingModule?.allowedUsMethods}
        availableInternationalMethods={
          onboardingModule?.allowedInternationalMethods
        }
        localCurrencyOnly={onboardingModule?.localCurrencyOnly}
      />
    </WSList>
  );
};
